import {
  TComponentValue,
} from '@/types/openapi-type.ts';

const details: Record<TComponentValue<'QmulusLicenseViolationReason'>, string> = {
  NO_LICENSE_KEY: 'Na pokračovanie používania Qmulus je potrebné zadať platný licenčný kľúč.',
  ASSET_LIMIT_VIOLATED: 'Bolo nakonfigurovaných príliš veľa zariadení.',
  EXPIRED: 'Licenčný kľúč vypršal pred viac ako {expiryGracePeriodDays} dňami',
  EXPIRED_GRACE_PERIOD: 'Licencia vypršala. Čo najskôr ju aktualizujte, inak stratíte prístup k Qmulus.',
  INVALID: 'Zadaný licenčný kľúč je neplatný.',
  USER_LIMIT_VIOLATED: 'Bolo nakonfigurovaných príliš veľa používateľov.',
  OTHER: 'Neznáma chyba pri overovaní licencie.',
};

export default {
  enterLicense: 'Zadajte licenčný kľúč',
  contactSales: 'Ak chcete získať novú licenciu, kontaktujte obchodného zástupcu Qmulus',
  ignore: 'Ignorovať',
  expiresSoon: {
    summary: 'Licenčný kľúč čoskoro vyprší',
    details: 'Licenčný kľúč vyprší {date}',
  },
  details,
};
